import { render, staticRenderFns } from "./FacebookShareButton.vue?vue&type=template&id=4bc2d39e"
import script from "./FacebookShareButton.vue?vue&type=script&lang=ts"
export * from "./FacebookShareButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports